export const STATES = {
  ABORTED: 'aborted',
  INITIAL: 'initial',
  REJECTED: 'rejected',
  TRANSFORMED: 'transformed',
  IN_PROGRESS: 'in-progress',
  WAITING_ROOM: 'waiting-room',
  TO_BE_VALIDATED: 'to-be-validated',
  PARTIALLY_REJECTED: 'partially-rejected',
  PAUSED_AND_RESCHEDULED: 'paused-and-rescheduled',
  INTO_VALIDATION: 'into-validation',
  TO_BE_PRE_VALIDATED: 'to-be-pre-validated',
  INTO_PRE_VALIDATION: 'into-pre-validation',
  COMPLETED: 'completed',
  EXTERNALLY_INVALIDATED: 'externally-invalidated',
};

export const TYPES = [
  'id_card',
  'passport',
  'driving_license',
  'italian_id_card',
  'old_driving_license',
  'health_insurance_card',
];

export const SESSION_MASSIVE_ACTION_LIMIT = 5;

export const PDF_TO_BE_SIGNED = 'pdf_to_be_signed';
export const MARKUP_PDF_TO_BE_SIGNED = 'markup_pdf_to_be_signed';
export const MARKUP_CONFIGURATION = 'markup_configuration';
export const XML_FOR_IDSIGN_ID = 'xml_for_idsign_id';
export const WAITING_ROOM_PATH = '/session-management/waiting-room';
export const WAITING_ROOM_SUPERVISOR_PATH =
  '/session-management/supervisor/waiting-room';
export const SESSION_TYPES = {
  SELFIE: 'selfie',
  OPERATOR: 'operator',
};

export const DOCUMENTS_TYPES = {
  FACE_MOVEMENT: 'face_movement',
};

export const TO_BE_SIGNED_DOCS = ['pdf_to_be_signed', 'cgs_to_be_signed'];
